import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const DetailPage = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    axios
      .get(`https://final-project-api-alpha.vercel.app/api/jobs/${id}`)
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="py-20 text-center">Loading...</p>;
  if (!data) return <p className="py-20 text-center">Data tidak ditemukan</p>;

  return (
    <div className="w-full ">
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="flex flex-col md:flex-row md:items-center md:gap-6">
            <img
              src={data.company_image_url}
              alt={data.company_name}
              className="w-20 h-20 object-contain rounded-lg border bg-white"
            />

            <div>
              <h1 className="text-4xl font-bold text-gray-900">{data.title}</h1>
              <p className="text-gray-600 mt-2">
                {data.company_name} • {data.company_city}
              </p>

              <div className="flex gap-2 mt-4">
                <span className="px-3 py-1 text-sm bg-indigo-100 text-indigo-600 rounded-full">
                  {data.job_type}
                </span>
                <span className="px-3 py-1 text-sm bg-green-100 text-green-600 rounded-full">
                  {data.job_tenure}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50">
        <div className="mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-2 space-y-10">
              <section>
                <h2 className="text-xl font-semibold mb-4">
                  Deskripsi Pekerjaan
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  {data.job_description}
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">Kualifikasi</h2>
                <p className="text-gray-700 leading-relaxed">
                  {data.job_qualification}
                </p>
              </section>
            </div>

            <aside className="bg-white rounded-xl border p-6 h-fit lg:sticky lg:top-24">
              <h3 className="text-lg font-semibold mb-4">
                Informasi Pekerjaan
              </h3>

              <div className="space-y-3 text-gray-700">
                <p>
                  <span className="font-medium">Tipe:</span> {data.job_type}
                </p>
                <p>
                  <span className="font-medium">Durasi:</span> {data.job_tenure}
                </p>
                <p>
                  <span className="font-medium">Gaji:</span>
                  <br />
                  Rp {data.salary_min.toLocaleString("id-ID")} – Rp{" "}
                  {data.salary_max.toLocaleString("id-ID")}
                </p>
              </div>

              <button className="w-full mt-6 bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition">
                Lamar Sekarang
              </button>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
